enum FormKeys {
  BREAKDOWN_INFO = 'breakdownInfo',
  CUSTOMER_INFO = 'customerInfo',
  EXTRAS = 'extras',
  KIOSK_USAGE = 'kioskPreferencesQuestions',
  MOBILITY = 'mobility',
  MOBILITY_PARKING = 'mobilityParking',
  PARKING = 'parking',
  QUESTIONS = 'questions',
  POLICIES = 'policies',
  REPAIR_ORDER = 'repairOrder',
  SIGNATURE = 'signature',
  VEHICLE_CHECK = 'vehicleCheck',
}

export const ALL_FORM_KEYS = Object.values(FormKeys);

/** @description Keys of form that are NOT reconciliated on refresh */
export const NON_CONCILIATABLE_FORM_KEYS = [
  FormKeys.BREAKDOWN_INFO,
  FormKeys.VEHICLE_CHECK,
];

/** @description Keys of form that ARE reconciliated on refresh */
export const CONCILIATABLE_FORM_KEYS = ALL_FORM_KEYS.filter((key) => !NON_CONCILIATABLE_FORM_KEYS.includes(key));

export const SIGNATURE_IGNORED_FORM_KEYS = [
  ...NON_CONCILIATABLE_FORM_KEYS,
  FormKeys.MOBILITY,
  FormKeys.MOBILITY_PARKING,
  FormKeys.PARKING,
  FormKeys.POLICIES,
  FormKeys.SIGNATURE,
];

export default FormKeys;
